import "./index.css"
import Plain from "./plain"
import Playful from "./playful"

export function App() {
  const isUwu = localStorage.getItem("is_uwu") === "true"

  return (
    <div className="relative">
      <div className="absolute z-10 top-10 right-10 flex items-center gap-8" style={{ color: isUwu ? "white" : "black" }}>
        <a href="/support">Support</a>
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms</a>
        <a href="/resources" rel="noopener noreferrer" target="_blank">
          Resources
        </a>
      </div>

      {isUwu ? <Playful /> : <Plain />}
    </div>
  )
}
